module.exports = __webpack_public_path__ + "media/images/device-others-icon-0c5391ff17ca31c3df5eeb1b7d20261f.svg";